'use strict'

export default function formatTime(time,emptyValue) {
  return time!==undefined
    ? new Date(time).toISOString().substring(0,19).replace("T"," ").concat(" GMT")
    : emptyValue;
}



// WEBPACK FOOTER //
// ./views/log/formatTime.js